interface DropdownVerticalPositionOptions {
    triggerTop: number
    triggerBottom: number
    dropdownHeight: number
    viewportHeight: number
    gap?: number
    viewportPadding?: number
}

export const getDropdownVerticalPosition = ({
    triggerTop,
    triggerBottom,
    dropdownHeight,
    viewportHeight,
    gap = 10,
    viewportPadding = 16,
}: DropdownVerticalPositionOptions) => {
    const spaceBelow = viewportHeight - viewportPadding - triggerBottom - gap
    const spaceAbove = triggerTop - viewportPadding - gap
    const openUpward = dropdownHeight > spaceBelow && spaceAbove > spaceBelow
    const preferredTop = openUpward
        ? triggerTop - gap - dropdownHeight
        : triggerBottom + gap
    const maxTop = Math.max(viewportPadding, viewportHeight - viewportPadding - dropdownHeight)

    return {
        top: Math.min(Math.max(preferredTop, viewportPadding), maxTop),
        placement: (openUpward ? 'top' : 'bottom') as 'top' | 'bottom',
    }
}
